import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';
import { AuthProvider } from './context/AuthContext';
import Login from './components/auth/Login';
import ProtectedRoutes from './routes/ProtectedRoutes';
import SharedProposalPage from './pages/SharedProposalPage';
import { PublicVacancies } from './pages/PublicVacancies';
import { VacancyDetails } from './pages/VacancyDetails';

const App: React.FC = () => {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <AuthProvider>
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/proposals/:token" element={<SharedProposalPage />} />
                    <Route path="/vagas/publicas" element={<PublicVacancies />} />
                    <Route path="/vagas/publicas/:id" element={<VacancyDetails />} />
                    <Route path="/*" element={<ProtectedRoutes />} />
                </Routes>
            </AuthProvider>
        </ThemeProvider>
    );
};

export default App; 